// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/visibility-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/visibility-definitions/visibility-definitions.js';

mount([g0]);
